import React from "react";
import SEO from "../components/SEO";
import Navbar from "../components/Navbar";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/mousewheel";

import l1 from "../assets/images/waveLogo.png";
import l2 from "../assets/images/waveLogoWhite.png";
import l3 from "../assets/images/techvivantaLogo.png";
import l4 from "../assets/images/techvivantaWhite.png";
import l5 from "../assets/images/atcLogo.png";
import l6 from "../assets/images/atcLogoWhite.png";
import l7 from "../assets/images/justCharterLogo.png";
import l8 from "../assets/images/jestCharterLogoWhite.png";
import l9 from "../assets/images/ezfixLogo.png";
import l10 from "../assets/images/restaurentLogo.png";

import s1 from "../assets/images/02.jpg";
import s2 from "../assets/images/01.png";
import s3 from "../assets/images/05.jpg";
import s4 from "../assets/images/03.png";
import s5 from "../assets/images/07.jpg";
import s6 from "../assets/images/12.png";
import s7 from "../assets/images/13.png";

const Portfolio = () => {
  const data = [
    {
      id: 1,
      name: "Wave",
      heading: "Landing page for a onewave platform",
      description:
        "I developed a powerful and user-friendly web app for OneWave, enabling seamless crypto payments, wallet management, and smooth transactions within a secure, performance-driven digital ecosystem.",
      logo1: l1,
      logo2: l2,
      image: s1,
      bgColor: "#2a72e1",
      maxWidth: null,
      url: "https://onewave.app/",
    },
    {
      id: 2,
      name: "Tech Vivanta",
      heading: "Landing page for a Tech Vivanta",
      description:
        "I developed a powerful and user-friendly web app for Tech Vivanta, enabling seamless animations, nice ui, and smooth transactions within a secure, performance-driven digital ecosystem.",
      logo1: l3,
      logo2: l4,
      image: s2,
      bgColor: "#3ca858",
      maxWidth: null,
      url: "https://techvivanta.com/",
    },
    {
      id: 3,
      name: "ATC Chain",
      heading: "Design Landing page for ATC chain india",
      description:
        "ATC Chain delivers end-to-end conveying solutions—offering modular belts, slat chains, sprockets and wear strips engineered for durability, precision and efficiency in industrial automation.",
      logo1: l5,
      logo2: l6,
      image: s3,
      bgColor: "#30447a",
      maxWidth: null,
      url: "https://atcchain.com/",
    },
    {
      id: 4,
      name: "Just Charter",
      heading: "Design and dev of a web-app for JustCharter",
      description:
        "Just Charter offers premium private jet booking services across World, providing luxury air travel, personalized itineraries, and seamless experiences for business executives, celebrities, and leisure travelers seeking comfort and convenience.",
      logo1: l7,
      logo2: l8,
      image: s4,
      bgColor: "#dda84a",
      maxWidth: null,
      url: "https://www.justcharter.in/",
    },
    {
      id: 5,
      name: "Anuchitrakala",
      heading: "Develop website for Anuchitrakala",
      description:
        "Anuchitra Kala showcases a curated collection of exclusive Indian artworks and prints—hand-picked masterpieces, delivered beautifully for your home or office.",
      logo1: null,
      logo2: null,
      image: s5,
      bgColor: "#000000",
      maxWidth: null,
      url: "http://anuchitrakala.in/",
    },
    {
      id: 6,
      name: "EasyFix",
      heading: "Develop Backend for EasyFix",
      description:
        "This home service booking app connects users with professionals for AC repair, plumbing, cleaning, beauty, and appliance services—offering easy scheduling, secure payments, and real-time booking management in one platform.",
      logo1: l9,
      logo2: null,
      image: s6,
      bgColor: "#42a5ca",
      maxWidth: null,
      url: "https://play.google.com/store/apps/details?id=com.service.easyfixs",
    },
    {
      id: 7,
      name: "TakeMYOrder",
      heading: "Develop Backend for TakeMYOrder",
      description:
        "TakeMYOrder is a restaurant management app designed to streamline ordering, table management, and billing. It helps restaurants handle orders efficiently, reduce errors, and improve customer service.",
      logo1: l10,
      logo2: null,
      image: s7,
      bgColor: "#f8b951",
      maxWidth: 80,
      url: "https://play.google.com/store/apps/details?id=com.pos.takemyorder",
    },
  ];
  return (
    <>
      <main className="page-wrapper">
        <SEO
          title="Portfolio - Tech Insights"
          schema={{
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Hiren Hadiya Blogs",
            url: "https://hadiya.in/portfolio",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://hadiya.in/portfolio",
              "query-input": "required name=search_term_string",
            },
          }}
        />
        <Navbar />
        <div class="vh-100 pt-5 pt-lg-4">
          <Swiper
            className="h-100"
            modules={[Mousewheel]}
            direction="vertical"
            mousewheel={true}
          >
            {data.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="position-relative h-100">
                  <div
                    className="position-absolute top-0 end-0 w-50 h-100 d-none d-lg-block"
                    style={{ backgroundColor: item.bgColor }}
                  ></div>
                  <div className="d-flex flex-column flex-lg-row align-items-center h-100 position-relative z-2">
                    <div
                      className="position-relative w-100 order-lg-2 d-flex align-items-center justify-content-center d-lg-block"
                      style={{ minHeight: "45%" }}
                    >
                      <div
                        className="position-absolute top-0 end-0 w-100 h-100 d-lg-none"
                        style={{ backgroundColor: item.bgColor }}
                      ></div>
                      <a onClick={() => window.open(item.url, "blank")}>
                        <img
                          className="d-block position-relative z-2 mx-auto scale-up"
                          src={item.image}
                          width="748"
                          alt={item.name}
                        />
                      </a>
                    </div>
                    <div className="w-100 order-lg-1 px-3 px-lg-4 py-4 pt-lg-0">
                      <div
                        className="text-center text-sm-start mx-auto"
                        style={{ maxWidth: "450px" }}
                      >
                        {item.logo1 && (
                          <img
                            className={`d-block ${
                              item.logo2 ? "d-dark-mode-none" : ""
                            } mx-auto mx-sm-0 mb-2 mb-lg-3`}
                            src={item.logo1}
                            alt={item.name}
                            onClick={() => window.open(item.url, "blank")}
                            style={
                              item.maxWidth === null
                                ? { maxWidth: "200px" }
                                : { maxWidth: item.maxWidth }
                            }
                          />
                        )}
                        {item.logo2 && (
                          <img
                            className="d-none d-dark-mode-block mx-auto mx-sm-0 mb-2 mb-lg-3"
                            src={item.logo2}
                            alt={item.name}
                            style={
                              item.maxWidth === null
                                ? { maxWidth: "200px" }
                                : { maxWidth: item.maxWidth }
                            }
                            onClick={() => window.open(item.url, "blank")}
                          />
                        )}
                        <h2 className="h1 pb-2 pb-sm-0">{item.heading}</h2>
                        <p className=" d-sm-block pb-3 pb-lg-4 mb-1">
                          {item.description}
                        </p>
                        {/* <a
                          className="btn btn-sm btn-outline-dark fs-sm rounded-pill"
                          href="portfolio-single-v1.html"
                        >
                          Read the full story
                        </a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* <!-- Scroll for more indicator --> */}
          <div class="position-fixed start-50 bottom-0 translate-middle-x rounded-4 rounded-bottom-0 bg-light shadow z-5 fs-sm fw-medium text-dark py-2 px-3">
            Scroll for more
          </div>
        </div>
      </main>
    </>
  );
};

export default Portfolio;
